import React from 'react';
import AnimatedSection from '../components/AnimatedSection';
import { motion } from 'framer-motion';
import HorizontalImageCarousel from '../components/HorizontalImageCarousel';

export const servicesData = [
  {
    id: 1,
    title1: "RESIDENTIAL",
    title2: "SERVICES",
    shortDescription: "Comprehensive residential solutions tailored to your living needs.",
    items: [
      "Kitchen Remodeling", "Bathroom Renovation", "Basement Finishing",
      "Home Additions", "Custom Home Building", "Flooring Installation",
      "Painting Services", "Roofing & Gutters", "Siding & Windows",
      "Decks & Patios", "Sunroom Installation", "Landscape Design"
    ],
    image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&q=80&w=1000",
  },
  {
    id: 2,
    title1: "COMMERCIAL",
    title2: "SERVICES",
    shortDescription: "Building business spaces that inspire success and growth.",
    items: [
      "Office Build-Outs", "Retail Spaces", "Restaurant Construction",
      "Warehouse Facilities", "Medical Facilities", "Tenant Improvements",
      "Commercial Flooring", "Parking Facilities", "Building Renovation",
      "Ground-Up Construction", "Multi-Family Housing", "Mixed-Use Development"
    ],
    image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&q=80&w=1000",
  },
  {
    id: 3,
    title1: "SPECIALTY",
    title2: "SERVICES",
    shortDescription: "Specialized construction solutions focusing on sustainability and value.",
    items: [
      "Green Building/LEED", "Energy Efficiency", "Historic Restoration",
      "ADA Compliance", "Project Management", "Design-Build Services",
      "Value Engineering", "Construction Consulting", "Real Estate Development",
      "Facility Maintenance", "Emergency Restoration", "Government Contracting"
    ],
    image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=2070&auto=format&fit=crop",
  },
  {
    id: 4,
    title1: "TECHNICAL",
    title2: "CAPABILITIES",
    shortDescription: "Advanced technical expertise ensuring quality and precision.",
    items: [
      "Advanced project management utilizing Building Information Modeling (BIM)",
      "In-house engineering and architectural design collaboration",
      "Preconstruction services: cost estimating, scheduling, value engineering",
      "Quality control/assurance exceeding industry standards",
      "Comprehensive safety programs with OSHA compliance",
      "Sustainable construction practices and green building expertise"
    ],
    image: "https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?auto=format&fit=crop&q=80&w=1000",
  }
];

const CoreServices = () => {

  return (
    <>
    <section className="w-full bg-gray-50 text-slate-800 py-20 px-4 md:px-12 font-sans" style={{ fontFamily: "Monstserrat, proxima-nova, Helveti, sans-serif" }}>
      <AnimatedSection animationType="fadeUp">
      {/* Page Header & Intro Text */}
      <div className="max-w-[1200px] mx-auto mb-20 text-center">
        <h2 className="text-4xl md:text-5xl font-semibold uppercase tracking-tight text-black mb-6">
          Core Services <span className="text-slate-300 font-light">&</span> Capabilities
        </h2>
        <motion.div 
          initial={{ width: 0 }}
          whileInView={{ width: 200 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="h-1 bg-[#2a3890] mx-auto rounded-full mt-2"
          />
        {/* <div className="w-48 h-1 bg-[#2a3890] mx-auto rounded-full mb-8"></div> */}

        <p className="text-lg md:text-xl text-slate-600 font-light max-w-4xl mx-auto leading-relaxed mt-4">
          TM International Group offers comprehensive construction and development services across residential, commercial, government, 
          and industrial sectors. Our capabilities span the full project lifecycle from initial planning and design through construction, 
          commissioning, and post-occupancy support.
        </p>
      </div>

      {servicesData.map((service, index) => {
        // Alternating Layout Logic
        const isImageLeft = index % 2 !== 0;

        return (
          <div 
            key={service.id} 
            className="mb-24 last:mb-0" 
          >
            <div
              className="max-w-[1200px] pl-10 pr-10 mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center"
            >
              {/* --- IMAGE SECTION --- */}
              <div className={`relative w-full group ${isImageLeft ? '' : 'lg:order-2'}`}>
                <div
                  className="relative overflow-hidden h-[300px] md:h-[400px] bg-center bg-cover shadow-lg transition-transform duration-500"
                  style={{ backgroundImage: `url(${service.image})` }}
                >
                </div>
              </div>

              {/* --- TEXT SECTION --- */}
              <div className={`space-y-6 ${isImageLeft ? 'lg:order-2' : ''} text-left`}>
                <div className="space-y-1 text-center lg:text-left">
                  <h3>
                    <span className="block text-slate-900 font-extrabold uppercase tracking-tight text-3xl md:text-5xl leading-none">
                      {service.title1}
                    </span>
                    <span className="block text-slate-900 font-extrabold uppercase tracking-tight text-3xl md:text-5xl leading-none lg:ml-12 mt-2 text-[#2a3890] lg:text-slate-900">
                      {service.title2}
                    </span>
                  </h3>
                </div>
                
                {/* List Items Grid */}
                <div className="pt-4">
                  <ul className="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-2">
                    {service.items.map((item, i) => (
                      <li key={i} className="flex items-start text-slate-600 font-light text-sm md:text-base">
                        <span className="mr-2 text-[#2a3890] mt-1.5 text-xs">●</span>
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        );
      })}
      </AnimatedSection>
    </section>
    <section>
      <HorizontalImageCarousel/>
    </section>
          <div className="bg-gray-900 max-w-full mx-auto px-4 text-center py-12 text-white" style={{ fontFamily: "Monstserrat, proxima-nova, Helveti, sans-serif" }}>
            <h2 className="text-2xl uppercase tracking-widest mb-4">Ready to build your vision?</h2>
            <button className="border border-white px-8 py-3 hover:bg-white hover:text-black transition uppercase text-sm tracking-wider"
              onClick={() => window.location.href = '/contact'}>
              Contact Us
            </button>
          </div>
    </>
  );
};

export default CoreServices;